import request from "@/utils/request";

export default function updateCamera(data) {
    return request({
        url: '/camera/update',
        method: 'post',
        data: data
    })
}
